import type {KeenSliderOptions} from "keen-slider";

export const SLIDER_CONFIG = {
    mobile: {perView: "auto" as const, spacing: 16},
    tablet: {perView: "auto" as const, spacing: 42},
    desktop: {perView: "auto" as const, spacing: 42},
} as const;

export function createSliderConfig(testimonialsCount: number): KeenSliderOptions | undefined {
    if (!testimonialsCount || testimonialsCount === 0) {
        return undefined;
    }

    return {
        slides: SLIDER_CONFIG.mobile,
        breakpoints: {
            "(min-width: 768px)": {
                slides: SLIDER_CONFIG.tablet,
            },
            "(min-width: 1500px)": {
                slides: SLIDER_CONFIG.desktop,
            },
        },
        drag: true,
        loop: testimonialsCount > 1,
        mode: "snap",
        initial: 0,
    };
}
